var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:`s-scrollbar__bar is-${_vm.bar.key}`,attrs:{"onMousedown":"clickTrackHandler"}},[_c('div',{ref:"thumb",staticClass:"s-scrollbar__thumb",style:(_vm.styles),attrs:{"onMousedown":"clickThumbHandler"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }